import React from 'react'
import Marquee from 'react-fast-marquee';

export const UpcomingTenders = () => {
    return (
        <div className={`flex flex-col gap-10 pb-20  `}>
            <h1 className='text-title-4 font-bold px-5 xl:px-15'>Upcoming Tender</h1>
            <div className='flex flex-col xl:flex-row gap-[30px]'>
                <Marquee speed={50} gradient={false} pauseOnHover={true} >
                    {TenderData.map((tender, idx) => (

                        <NewTenderCard label={tender.label} id={tender.id} bidDate={tender.bidDate} location={tender.location} tenderValue={tender.tenderValue} productCategory={tender.productCategory} periodOfWorks={tender.periodOfWorks} referenceNumber={tender.referenceNumber} key={idx} />
                    ))}
                </Marquee>
            </div>
        </div>
    )
}



export interface TenderCardProps {
    label: string;
    id: string;
    bidDate: string;
    location: string;
    tenderValue: string;
    productCategory: string;
    periodOfWorks: string;
    referenceNumber: string;
}

export const TenderData: TenderCardProps[] = [
    {
        bidDate: "OCT 05",
        id: "2024_MoRTH_829402_1",
        label: "Ministry of Road Transport and Highways",
        location: "Arabhavi",
        periodOfWorks: "335",
        productCategory: "Civil Works - Bridges",
        referenceNumber: "EE/HBL/IFT/CRIF/24/25/1259/01 Dt04/10/2024",
        tenderValue: "4,86,04,882"
    },
    {
        bidDate: "NOV 12",
        id: "2024_MRVC_827690_1",
        label: "Ministry of Railways-World Bank Tenders",
        location: "Near Bhayander Station",
        periodOfWorks: "910",
        productCategory: "Civil Works - Bridges",
        referenceNumber: "MRVC/W/224",
        tenderValue: "5,45,20,42,191"
    },
    {
        bidDate: "OCT 17",
        id: "2024_MoRTH_831331_1",
        label: "Ministry of Road Transport and Highways",
        location: "KESINGA DIVISION",
        periodOfWorks: "730",
        productCategory: "Civil Works - Bridges",
        referenceNumber: "09 CE NH of 2024-25",
        tenderValue: "26,12,00,000"
    },
    {
        bidDate: "OCT 14",
        id: "2024_ARMHA_830594_2",
        label: "Assam Rifles - MHA",
        location: "Jorhat(Assam)",
        periodOfWorks: "180",
        productCategory: "Civil Works - Water Works",
        referenceNumber: "25 Sect/Engr/Deptl/WSS/2024/8777",
        tenderValue: "86,27,887"
    },
    {
        bidDate: "OCT 21",
        id: "2024_IWAI_831136_1",
        label: "Inland Waterways Authority of India,MoS",
        location: "IWAI RO Kochi",
        periodOfWorks: "180",
        productCategory: "Civil Works - Water Works",
        referenceNumber: "IWAI/COCH/57(1)/2024-25/65",
        tenderValue: "84,74,042"
    },
    {
        bidDate: "OCT 17",
        id: "2024_IITK_830287_1",
        label: "Indian Institute of Technology Kanpur",
        location: "Mathura, UP",
        periodOfWorks: "540",
        productCategory: "Civil Works - Water Works",
        referenceNumber: "CGANGA/IITK/2024-25/02",
        tenderValue: "30,00,00,000"
    },
]


// export const TenderCard = ({ logo, couponRate, gradeType,
//     ipFrequency,
//     label,
//     minInvest,
//     price,
//     segment,
//     tenderType,
//     tenure,
//     yieldPercent
// }: TenderCardProps) => {
//     return (
//         <div className='border border-grey-200 rounded-lg w-full xl:w-[500px]'>
//             <div className='p-6 flex flex-col gap-8'>
//                 <div className='flex flex-col gap-6'>
//                     <div className='flex gap-[14px] items-center'>

//                         <Image src={logo} alt='' width={60} height={61} className='object-contain' />
//                         <h1 className='text-title-6 font-bold'>{label}</h1>
//                     </div>
//                     <div className='flex flex-col sm:flex-row gap-6'>
//                         <div className='flex gap-2 border border-success bg-surface-green rounded-lg py-3 px-4 text-center w-full'>
//                             <h1 className='flex gap-1'>
//                                 <span className='font-bold text-body-1'>Segment:</span>
//                                 <span className='font-medium text-body-1 text-green-800'>{segment}
//                                 </span>
//                             </h1>
//                             |
//                             <h1 className='flex gap-1'>
//                                 <span className='font-bold text-body-1'>Type:</span>
//                                 <span className='font-medium text-body-1 text-green-800'>{tenderType}
//                                 </span>
//                             </h1>
//                         </div>
//                         <div className='border border-grey-200 rounded-lg py-3 px-4 text-center w-[100px] sm:w-full'>{gradeType}</div>
//                     </div>
//                 </div>
//                 <div className='grid grid-cols-2 sm:grid-cols-3 gap-y-6'>
//                     <div className='w-[170px] flex flex-col '>
//                         <h1 className='text-body-3 text-grey-700 font-normal'>Tenure</h1>
//                         <h1 className='text-body-1 font-bold'>{tenure}</h1>
//                     </div>
//                     <div className='w-[170px] flex flex-col '>
//                         <h1 className='text-body-3 text-grey-700 font-normal'>Min. Investment</h1>
//                         <h1 className='text-body-1 font-bold'>{minInvest}</h1>
//                     </div>

//                     <div className='w-[170px] flex flex-col '>
//                         <h1 className='text-body-3 text-grey-700 font-normal'>IP Frequency</h1>
//                         <h1 className='text-body-1 font-bold'>{ipFrequency}</h1>
//                     </div>

//                     <div className='w-[170px] flex flex-col '>
//                         <h1 className='text-body-3 text-grey-700 font-normal'>Coupon Rate</h1>
//                         <h1 className='text-body-1 font-bold'>{couponRate}</h1>
//                     </div>

//                     <div className='w-[170px] flex flex-col '>
//                         <h1 className='text-body-3 text-grey-700 font-normal'>Price</h1>
//                         <h1 className='text-body-1 font-bold'>{price}</h1>
//                     </div>

//                     <div className='w-[170px] flex flex-col '>
//                         <h1 className='text-body-3 text-grey-700 font-normal'>Yield(%)</h1>
//                         <h1 className='text-body-1 font-bold'>{yieldPercent}</h1>
//                     </div>
//                 </div>
//             </div>

//         </div>
//     )
// }

export const NewTenderCard = ({ label, bidDate, id, location, periodOfWorks, productCategory, referenceNumber, tenderValue, }: TenderCardProps) => {
    return (
        <div className='border border-grey-200 rounded-xl flex flex-col h-full mr-5'>
            <div className='p-6 flex gap-6 bg-surface-blue rounded-t-xl items-center border-b border-grey-200'>
                <div className='bg-primary flex flex-col gap-2 items-center py-[10px] px-3 rounded-[10px]'>
                    <h1 className='text-title-5 text-white font-bold'>{bidDate.slice(4, 6)}</h1>
                    <p className='text-body-3 font-medium text-white'>{bidDate.slice(0,3)} 24</p>
                </div>
                <div className='flex flex-col gap-2 '>
                    <h1 className='font-bold text-title-6 max-w-[320px]'>{label}</h1>
                    <p className='font-normal text-body-1 text-grey-900 text-left'>{id}</p>
                </div>
            </div>
            <div className='p-6 grid grid-cols-2 gap-8'>
                <div className='flex flex-col gap-1'>
                    <h1 className='text-body-3 font-normal'>Location</h1>
                    <h1 className='text-body-1 font-medium'>{location}</h1>
                </div>
                <div className='flex flex-col gap-1'>
                    <h1 className='text-body-3 font-normal'>Tender Value</h1>
                    <h1 className='text-body-1 font-medium'>{tenderValue}</h1>
                </div>
                <div className='flex flex-col gap-1'>
                    <h1 className='text-body-3 font-normal'>Product Category</h1>
                    <h1 className='text-body-1 font-medium'>{productCategory}</h1>
                </div>
                <div className='flex flex-col gap-1'>
                    <h1 className='text-body-3 font-normal'>Period Of Work(Days)</h1>
                    <h1 className='text-body-1 font-medium'>{periodOfWorks}</h1>
                </div>
                <div className='col-span-2'>

                    <div className='flex flex-col gap-1'>
                        <h1 className='text-body-3 font-normal'>Tender Reference Number</h1>
                        <h1 className='text-body-1 font-medium'>{referenceNumber}</h1>
                    </div>
                </div>
            </div>
        </div>
    )
}